import type {PropsWithChildren} from 'react'
import {useSlots} from '@primer/react/experimental'
import styles from './Row.module.css'
import {clsx} from 'clsx'

Row.LeadingVisual = LeadingVisual
Row.Actions = Actions
Row.Description = Description
export {Row}

const rowSlotConfig = {
  leadingVisual: Row.LeadingVisual,
  actions: Row.Actions,
  description: Row.Description,
}

function Row({className, children: slottedChildren}: PropsWithChildren<{className?: string}>) {
  const [{actions, description, leadingVisual}, children] = useSlots(slottedChildren, rowSlotConfig)
  return (
    <li className={clsx('Box-row d-flex flex-row flex-justify-between flex-items-center', styles.Row, className)}>
      <div className={styles.Content}>
        {leadingVisual ? <div className={styles.LeadingVisual}>{leadingVisual}</div> : null}
        {children ? <div className={styles.Children}>{children}</div> : null}
        {description ? <div className={styles.Description}>{description}</div> : null}
      </div>
      <div>{actions}</div>
    </li>
  )
}
Row.displayName = 'PanelList.Row'

function LeadingVisual({
  children,
  align,
}: PropsWithChildren<{
  align?: 'center' | 'start' | 'end'
}>) {
  return <span className={`flex-self-${align ?? 'center'}`}>{children}</span>
}
LeadingVisual.displayName = 'PanelList.Row.LeadingVisual'

function Actions({children}: PropsWithChildren) {
  return <div className="d-flex flex-row flex-items-center gap-1">{children}</div>
}
Actions.displayName = 'PanelList.Row.Actions'

function Description({children}: PropsWithChildren) {
  return children
}
Description.displayName = 'PanelList.Row.Description'
